export enum EventRowVariant {
	List = "list",
	Preview = "preview",
}
